<ng-multiselect-dropdown [placeholder]="'Tier(s)'" [settings]="dropdownSettings" [data]="dropdownList" appendTo="body" [disabled]="isDropdownDisabled"
    [(ngModel)]="selectedItems" (onSelect)="changeItems()" (onDeSelect)="changeItems()" (onSelectAll)="allItems($event)"
    (onDeSelectAll)="anyItems()">
</ng-multiselect-dropdown>